import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { OrganizationLogo } from 'src/components/Organization';
import { Separator } from '@/components/ui/separator';
import { apolloCache } from 'src/graphql';
import { CompanyDocument, type ICompanyQuery } from 'src/graphql/actions/company/company.query';
import { ProfileDocument, type IProfileQuery } from 'src/graphql/actions/profile/profile.query';

const DetailRow = ({ label, value }: { label: string; value: string | null }) => (
  <div className="grid grid-cols-1 sm:grid-cols-[200px_16px_1fr] text-sm py-3 border-t gap-1">
    <span className="font-semibold text-slate-700">{label}</span>
    <span className="hidden text-slate-400 sm:inline">:</span>
    <span className="text-foreground">{value || '-'}</span>
  </div>
);

const SummaryDetailCard = () => {
  const company = apolloCache.readQuery<ICompanyQuery>({ query: CompanyDocument })?.company;
  const profile = apolloCache.readQuery<IProfileQuery>({ query: ProfileDocument })?.profile;

  const organizationName = company?.companyName ?? null;
  const sentBy = [profile?.name, profile?.email].filter(Boolean).join(' · ');

  return (
    <Card>
      <CardHeader className="flex-row gap-2.5 space-y-0 p-5 pb-2.5">
        <OrganizationLogo
          name={organizationName ?? ''}
          logo={company?.companyWebsite ?? undefined}
          rounded="md"
          className="shrink-0"
          classes={{
            fallback: 'text-white bg-slate-400 text-xs',
          }}
        />
        <div className="space-y-0.5">
          <CardTitle className="text-sm font-semibold">Your details</CardTitle>
          <CardDescription className="text-xs">What the vendor sees when they receive this request.</CardDescription>
        </div>
      </CardHeader>
      <CardContent className="p-5 pt-0">
        <DetailRow label="Organization name" value={organizationName} />
        {company?.companyWebsite && <DetailRow label="Website" value={company.companyWebsite} />}
        <DetailRow label="Sent by" value={sentBy} />
        <Separator />
      </CardContent>
    </Card>
  );
};

export default SummaryDetailCard;
